import React from 'react';
import moment from 'moment';
import { Card, CardHeader, CardContent } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Divider from '@material-ui/core/Divider';


export default function NylegAtkvaediTable(props) {
  const { atkvaedi, embaetti } = props;
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Card>
      <CardHeader title={"Nýleg atkvæði"} subheader={embaetti} />
      <Divider />
      <CardContent style={{ overflowX: 'auto' }}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Kennitala</TableCell>
              <TableCell>Nafn</TableCell>
              <TableCell>Heimili</TableCell>
              <TableCell>Sveitarfélag</TableCell>
              <TableCell>Atkvæði</TableCell>
              <TableCell>Tímastimpill</TableCell>
              <TableCell>Gilt</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {atkvaedi
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map(a => (
                <TableRow key={a.id}>
                  <TableCell>{a.kennitala}</TableCell>
                  <TableCell>{a.nafn}</TableCell>
                  <TableCell>{a.heimili}</TableCell>
                  <TableCell>{a.sveitarfelag}</TableCell>
                  <TableCell>{a.atkvaediTegund.lysing === "Aðsent atkvæði" ? "-" : a.atkvaediTegund.lysing}</TableCell>
                  <TableCell>{moment(a.dagsetning).format('DD.MM.YYYY HH:mm')}</TableCell>
                  <TableCell>{!a.ogilt ? 'Já' : 'Nei'}</TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={atkvaedi.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </CardContent>
    </Card>
  );
}